function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2f3030;}.b{fill:#3e4142;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(5.079 2.501)"
}, /*#__PURE__*/React.createElement("ellipse", {
  className: "a",
  cx: 11.119,
  cy: 3.435,
  rx: 11.119,
  ry: 3.435,
  transform: "translate(-5.079 11.109)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M142.838,275.425c0,1.9-22.238,1.9-22.238,0s4.877-4.412,11.018-4.412S142.838,273.523,142.838,275.425Z",
  transform: "translate(-125.678 -260.882)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M2.677,0C4.23.032,5.551,4.591,5.627,10.183S4.506,20.282,2.953,20.25.08,15.66,0,10.068,1.124-.032,2.677,0Z",
  transform: "translate(-4.308 11.564) rotate(-86.618)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M146.519,212.6c-.124,1.55-20.049.7-19.925-.847s4.691-2.618,10.195-2.379S146.643,211.05,146.519,212.6Z",
  transform: "translate(-130.59 -203.527)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M2.544,0C3.921-.011,5.014,3.362,4.987,7.534S3.82,15.1,2.443,15.108-.027,11.746,0,7.574,1.167.011,2.544,0Z",
  transform: "translate(-1.434 7.015) rotate(-92.218)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M161.632,147.673c.065,1.377-15.178,1.86-15.244.483s3.293-2.6,7.5-2.737S161.574,146.3,161.632,147.673Z",
  transform: "translate(-147.994 -143.94)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "a",
  cx: 2.117,
  cy: 3.608,
  rx: 2.117,
  ry: 3.608,
  transform: "translate(2.28 1.894) rotate(-85.998)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M199.286,102.109c-.084,1.169-7.281.662-7.2-.5s1.759-2,3.745-1.86S199.363,100.941,199.286,102.109Z",
  transform: "translate(-189.661 -102.233)"
}));

var SvgStones = function SvgStones(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "-1 -1 24 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStones, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stones.7688c786.svg";
export { ForwardRef as ReactComponent };